import { List, fromJS } from 'immutable';
import * as actions from '../utils/Constants'

export default (state = getInitialState(), action) => {
    switch (action.type) {

        case actions.DELETE_SESSION + actions.FULFILLED:
        case actions.GET_SESSIONS + actions.FULFILLED:
            {
                return fromJS(action.payload);
            }
        default:
            return state;
    }
}

const getInitialState = () => {
    return List();
}